import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta'

Vue.use(VueRouter);
Vue.use(VueMeta)

const routes = [];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
